import React, { Component } from 'react';

import 'rc-slider/assets/index.css';
import "./intensity.css";

import Slider from 'rc-slider';
import FlatUIButton from './flat-ui-button.js';

export default class IntensitySelector extends Component {
  static defaultProps = {
    defaultValue: 50
  }

  state = {
    value: this.props.defaultValue,
    interacted: false,
    values: this.props.values || {},
    interactions: {}
  }

  onSubmit() {
    if (this.props.stackedOptions) {
      let selections = JSON.stringify(this.props.stackedOptions.map(opts => this.state.values[opts[opts.length - 1]]))
      // console.log(selections)
      this.props.addMessage(selections, {})
    } else {
      this.props.addMessage("" + this.state.value, {})
    }
  }
  
  render() {
    return (
      <div className={"input" + (this.props.static ? " compact" : "")}>
        { this.props.stackedOptions ? this.renderMultiSlider() : this.renderSingleSlider() }
        { 
          !this.props.static &&
           <div className="centered submit-container">
            <FlatUIButton disabled={!this.state.interacted} className="rounded primary submit-button" 
                onClick={e => this.onSubmit()}>
              OK
            </FlatUIButton>
          </div>
        }
       
        
      </div>
    )
  }

  renderMultiSlider() {
    return (
      <div>
        {
          this.props.stackedOptions.map(opts => {
            let opta = opts[0]
            let optb = opts[opts.length - 1]
            return (
              <div className="slider-container" key={optb}>
                <Slider
                  className={this.props.static || this.state.interactions[optb] ? "interacted" : "not-interacted"}
                  defaultValue={this.state.values[optb] || this.props.defaultValue}
                  disabled={this.props.static}
                  tipFormatter={v => v + "%"}
                  tipProps={{placement: 'bottom'}}
                  onChange={v => this.setState(state => {
                    state.values[optb] = v
                    if (state.interactions[optb]) {
                      return { values: state.values }
                    }

                    state.interactions[optb] = true
                    let interactionValues = this.props.stackedOptions.map(k => state.interactions[k[k.length - 1]])
                    return {
                      values: state.values,
                      interactions: state.interactions,
                      interacted: interactionValues.every(v => v)
                    }
                  })}
                />
                <div className="slider-axis">
                  <div>{opta}</div>
                  <div>{optb}</div>
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }

  // this.props.stackedOptions.map(opt => (
          //   <Slider 
          //     defaultValue={this.props.defaultValue}
          //     disabled={this.props.static}
          //     onChange={v => this.setState({ value: v })}
          //     onAfterChange={v => this.setState({ interacted: true })}
          //   />
          // ))
        // }

  renderSingleSlider = () => (
    <div className="slider-container">
      <Slider 
        defaultValue={this.props.defaultValue}
        disabled={this.props.static}
        onChange={v => this.setState({ value: v, interacted: true })}
      />
      <div className="slider-axis">
        <div>{this.props.optionLow}</div>
        <div>{this.props.optionHigh}</div>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/input/intensity.js